import { AlluLogo } from "./AlluLogo";

export const ParceirosFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#FAF8F5] border-t border-zinc-200">
      <div className="container-wide py-10 sm:py-12">
        {/* Linha 1: logo + copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pb-8 sm:pb-10 border-b border-zinc-200">
          <AlluLogo variant="dark" className="h-8 w-auto" />

          <p className="text-xs text-zinc-500 text-center sm:text-right max-w-md">
            © {year} Allu Invest. Programa de Parceiros restrito a profissionais
            certificados do mercado financeiro com base ativa de clientes.
          </p>
        </div>

        {/* Disclaimers regulatórios */}
        <div className="pt-8 sm:pt-10 space-y-4 text-[11px] sm:text-xs leading-relaxed text-zinc-500 max-w-4xl">
          <p>
            Esta página tem caráter exclusivamente institucional e destina-se à
            apresentação do programa de parcerias da Allu Invest a profissionais
            do mercado financeiro brasileiro. O conteúdo aqui veiculado não
            constitui, e não deve ser interpretado como, oferta pública de
            divulgação de valores mobiliários, recomendação de investimento,
            consultoria de valores mobiliários ou solicitação de adesão a
            produto financeiro, nos termos da Resolução CVM nº 160/2022 e da
            Resolução CVM nº 19/2021. A relação de parceria descrita nesta
            página é de natureza comercial entre pessoas jurídicas e/ou
            profissionais autônomos credenciados, não configurando vínculo
            empregatício, mandato ou representação para fins de captação
            pública de recursos.
          </p>

          <p>
            A <strong className="text-zinc-700 font-medium">
              COMPANHIA SECURITIZADORA ALLU INVEST S.A.
            </strong>{" "}
            (CNPJ: 62.446.127/0001-96) é emissora de debêntures de
            securitização. A divulgação pública desses valores mobiliários
            ocorre exclusivamente por meio de plataformas eletrônicas de
            investimento participativo que atendem à legislação aplicável, nos
            termos da Resolução CVM nº 88/2022. Nos termos da Resolução CVM nº
            88, a{" "}
            <strong className="text-zinc-700 font-medium">
              DEXCAP INVESTIMENTOS E TECNOLOGIA LTDA.
            </strong>{" "}
            (CNPJ: 49.637.048/0001-02) está autorizada a realizar a divulgação
            de valores mobiliários de emissão de títulos financeiros
            securitizados, com dispensa de registro, por meio de plataforma
            eletrônica de investimento participativo (“Plataforma de
            Crowdfunding”). As ofertas da Securitizadora Allu Invest, quando
            existentes, podem ser acessadas exclusivamente na página da oferta
            na plataforma.
          </p>
        </div>
      </div>
    </footer>
  );
};
